import * as React from "react";
import { AuditList } from "../common/AuditList";

const UserAudit = () => <AuditList resource="users" />;

export default UserAudit;
